<template>
    <new-student-backend-layout
        page-title="Student Dashboard"
        content-bg-color="gray-125"
        header-bg-color="white"
    >
        <template #page_header>
            <div class="flex flex-col gap-4 pt-4">
                <h1 class="text-[26px] font-semibold">Quizzes</h1>
                <div class="text-[16px] text-gray-700">
                    Thousands of quiz questions across the 5 focus areas tested
                    on the NREMT exam
                </div>
                <div class="overflow-x-auto">
                    <div class="flex w-[1px] flex-row gap-4">
                        <div class="flex-none">
                            <StudentDashboardWidget
                                title="Incorrect Answers"
                                :value="$page.props.studentMissedQuestionsCount"
                            >
                                <div class="mt-auto p-3">
                                    <Link
                                        v-if="
                                            $page.props
                                                .studentMissedQuestionsCount
                                        "
                                        :href="
                                            route('student.quiz.start', {
                                                quiz_type: 'missed',
                                            })
                                        "
                                        class="rounded bg-primary-525 px-3 py-2 text-[14px] text-white hover:cursor-pointer hover:bg-primary-625"
                                    >Take Quiz
                                    </Link>
                                    <span
                                        v-else
                                        class="rounded bg-gray-125 px-3 py-2 text-[14px] text-gray-425 hover:cursor-not-allowed"
                                    >
                                        Take Quiz
                                    </span>
                                </div>
                            </StudentDashboardWidget>
                        </div>
                        <div class="max-w-xl flex-none">
                            <StudentDashboardWidget
                                title="Average Score"
                                :value="
                                    Math.round(
                                        $page.props.studentAverageQuizScore *
                                            100
                                    ) + '%'
                                "
                                reason="Last 500 Questions"
                            />
                        </div>
                        <div class="max-w-xl flex-none">
                            <StudentDashboardWidget
                                title="Questions Answered"
                                :value="
                                    $page.props.studentTotalQuestionsAnswered.toLocaleString()
                                "
                                reason="All Time"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="-mb-4 mt-8">
                <MobileTabSelector
                    :tab-options="{
                        'focus-areas': 'Focus Areas',
                        'quiz-modes': 'Quiz Modes',
                        'past-results': 'Past Results',
                    }"
                    :current-tab="mobileTab"
                    v-on:tab-selected="setMobileTab"
                />
            </div>
        </template>

        <template #content>
            <div class="px-0 py-4 md:px-4 lg:px-10">
                <div
                    :class="
                        'mb-4' +
                        ' ' +
                        (mobileTab === 'focus-areas' ? '' : 'hidden md:block')
                    "
                >
                    <StudentQuizzesByFocusAreaTable
                        :student-focus-areas-with-performance="
                            studentFocusAreasWithPerformance
                        "
                    />
                </div>

                <div
                    :class="
                        'mb-4' +
                        ' ' +
                        (mobileTab === 'quiz-modes' ? '' : ' hidden md:block')
                    "
                >
                    <StudentQuizzesAdditionalQuizTypesTable/>
                </div>
                <div
                    :class="
                        'mb-4' +
                        ' ' +
                        (mobileTab === 'past-results' ? '' : ' hidden md:block')
                    "
                >
                    <StudentQuizzesPastQuizzes :past-quizzes="pastQuizzes"/>
                </div>
            </div>
        </template>
    </new-student-backend-layout>
</template>

<script>
import NewStudentBackendLayout from "@/_Layouts/NewStudentBackendLayout.vue";
import StudentDashboardWidget from "@/Components/StudentDashboardWidget.vue";
import StudentQuizzesPastQuizzes from "@/Components/StudentQuizzesPastQuizzes.vue";
import StudentQuizzesByFocusAreaTable from "@/Components/StudentQuizzesByFocusAreaTable.vue";
import StudentQuizzesAdditionalQuizTypesTable from "@/Components/StudentQuizzesAdditionalQuizTypesTable.vue";
import MobileTabSelector from "@/Pages/NewStudentBackend/MobileTabSelector.vue";

export default {
    name: "StudentQuizzesIndex",
    components: {
        MobileTabSelector,
        StudentQuizzesAdditionalQuizTypesTable,
        StudentQuizzesByFocusAreaTable,
        NewStudentBackendLayout,
        StudentDashboardWidget,
        StudentQuizzesPastQuizzes,
    },
    props: {
        studentFocusAreasWithPerformance: {
            type: Object,
            default: {},
        },
        pastQuizzes: {
            type: [Object, Array],
            default: {},
        },
    },
    data() {
        return {
            // mobileTab: "past-results",
            mobileTab: "focus-areas",
        };
    },
    methods: {
        setMobileTab(tabKey) {
            this.$nextTick(function () {
                this.mobileTab = tabKey;
            });
        },
    },
};
</script>

<style scoped></style>
